<template>
  <div v-if="distributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="distributions"
      dataFormaterKey="order.shop.print_distribution_template.template"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Orders from "@/api/orders";
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import makeData from "../distributions/makeData";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    distributions: [],
    pageCounter: 0,
  }),

  computed: {
    ...mapState(["accountUser"]),
  },

  mounted() {
    PrintTemplates.fetchOne("distribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.formater = response.data.print_template.template;
          //获取单据详情
          Orders.orderToDistributionPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                var order = response.data.order;
                var order_address = response.data.order_address;
                order.shop = this.$printUtils.addCitiesName(order.shop);
                var distributions = [];
                if (order.distributions) {
                  order.distributions.forEach((distribution) => {
                    distributions.push({
                      order: order,
                      distribution: makeData.processDetails(distribution),
                      order_address: order_address,
                      print_date: new Date().toISOString().substr(0, 10),
                      printDateMinutes: this.$datetimeUtils.formatDateMinutes(
                        new Date()
                      ),
                      accountUserName: this.accountUser.name,
                    });
                  });
                }
                this.distributions = distributions;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>